import styled from 'styled-components';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import CardMedia from '@material-ui/core/CardMedia';
import ButtonBase from '@material-ui/core/ButtonBase';

export const StyledCard = styled(Card)`
    ${({
        theme,
        padding,
        $hoverPadding,
        margin,
        $noShadow,
        $backgroundColor,
        $hoverBackgroundColor,
        $maxWidth,
        $minWidth,
        $borderRadius,
        $width,
        $transparent,
        $borderWidth,
        $borderColor,
        $hoverBorderWidth,
        $hoverBorderColor,
    }) => `
    border-radius: ${$borderRadius ? $borderRadius : '16px'};
    box-sizing: border-box;
    border: ${$borderWidth ? $borderWidth : '1px'} solid ${
        $borderColor ? theme.palette.common[$borderColor] : theme.palette.common.white
    };
    ${
        $hoverBorderColor
            ? `
        &:hover {
           border: ${$hoverBorderWidth ? $hoverBorderWidth : '1px'} solid ${
                  theme.palette.common[$hoverBorderColor]
              };
        }    
    `
            : ''
    }
    box-shadow: ${$noShadow ? 'none' : '-1px 9px 18px rgba(95, 102, 140, 0.06)'};

    padding: ${padding ? padding : '24px'};
    ${
        $hoverPadding
            ? `
        &:hover {
            padding: ${$hoverPadding};
        }    
    `
            : ''
    }

    margin: ${margin ? margin : 0};

    max-width: ${$maxWidth ? $maxWidth : 'none'};
    min-width: ${$minWidth ? $minWidth : 0};

    position: relative;

    width: ${$width ? $width : '100%'};

    background: ${
        $backgroundColor
            ? theme.palette.common[$backgroundColor]
            : theme.palette.common.shadeGrayGradient
    };

    ${
        $hoverBackgroundColor
            ? `
                &:hover {
                    background: ${theme.palette.common[$hoverBackgroundColor]};
                }
    `
            : ''
    }

    ${
        $transparent
            ? `background: transparent;
        box-shadow: none;
        border: 1px solid transparent;
        `
            : ''
    }
    `}
`;

export const StyledCardContent = styled(CardContent)`
    ${() => `
    padding: 0;
       &:last-child{
        padding: 0;
    }
    `}
`;

export const StyledCardMedia = styled(CardMedia)`
    ${({ $imgMargin, $imgwidth, $imgMaxWidth }) => `
    margin: ${$imgMargin ? $imgMargin : 'auto'};
    width: ${$imgwidth ? $imgwidth : '100%'};
    max-width: ${$imgMaxWidth ? $imgMaxWidth : '100%'};
`}
`;

export const StyledNewsCardHeader = styled(CardHeader)`
    ${({ theme }) => `
    padding: 0;
    margin-bottom: 5px;
    text-align: center;
    font-weight: 600;
    color: ${theme.palette.primary.main};
`}
`;

export const StyledTermCard = styled(Card)`
    ${({ theme }) => `
    background: ${theme.palette.common.white};
    opacity: 0.9;
    border: 1px solid ${theme.palette.common.white};
    box-sizing: border-box;
    box-shadow: inset 0px 4px 8px rgba(204, 208, 227, 0.3);
    backdrop-filter: blur(4px);

    border-radius: 16px;

    `}
`;

export const StyledTermCardContent = styled(CardContent)`
    ${() => `
    padding: 25px;
    max-height: 70vh;
    overflow: auto;
    

    &:last-child{
     padding: 0;
    }
    `}
`;

export const StyledTermCardActions = styled(CardActions)`
    ${() => `
    background-image: linear-gradient(118deg, rgba(233,232,249, 0.9) 9.8%, rgba(248,246,253, 0.19) 77.52%);
    opacity: 0.9;
    box-sizing: border-box;
    box-shadow: 0px 4px 8px rgba(204, 208, 227, 0.3);
    backdrop-filter: blur(4px);

    padding: 25px 10px;

    `}
`;
export const StyledAppointmentCardHeader = styled.div`
    ${({ theme }) => `
        display: flex;
        align-items:center;
        background-color: ${theme.palette.primary.main};
        width: 100%;
        padding: 8px 15px;
   `}
`;

export const StyledSummaryCardAction = styled(CardActions)`
    ${({ theme, $loading }) => `
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    background: ${$loading ? theme.palette.common.gray2 : theme.palette.primary.main};

    `}
`;

export const StyledContractContainer = styled.div`
    ${({ mdUp }) => `
    display: grid;
    column-gap: 20px;
    grid-template-columns: ${mdUp ? 'auto 1fr' : '1fr'};
    align-items: flex-start;

    `}
`;

export const StyledAvatarContainer = styled.div`
    ${() => `
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    `}
`;

export const StyledContractContent = styled.div`
    ${() => `
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    row-gap: 25px;
    `}
`;

export const StyledTextContainer = styled.div`
    ${({ mdUp }) => `
    width: 100%;
    padding-left: ${mdUp ? '0' : '15px'};
    `}
`;

export const StyledButtonWrapper = styled(ButtonBase)`
    ${() => `
    &:hover {
        border-radius: 16px;
    }
    `}
`;
